import React from 'react';
import trix from 'trix'; // eslint-disable-line no-unused-vars
import { TrixEditor } from "react-trix";

import GlobalData from '../../context/globaldata';

class Notes extends React.Component {
  static contextType = GlobalData;

  state = {
    notes: ''
  };

  handleChange = (html, text) => {
    this.setState({
      notes: html
    });
  };

  handleEditorReady = (editor) => {
    this.editor = editor;

    this.setState({
      notes: this.props.content
    });

    // document.addEventListener('trix-change', event => {

    // });

    document.addEventListener('trix-file-accept', event => {
      if(!this.context.userSettings.premium_user) {
        // Block attachment events when user has 'free' subscription.
        event.preventDefault();
        this.context.addNotification('Error', "You need a subscription to be able to attach images", 'danger', 'right', 'bottom-right');
      } else {
        if(event.file.type !== "image/png" && event.file.type !== "image/jpeg") {
          event.preventDefault();
          this.context.addNotification('Error', "File is not a valid image, you can only upload PNG and JPG files", 'danger', 'right', 'bottom-right');
        }
        if(event.file.size > 2000000) {
          event.preventDefault();
          this.context.addNotification('Error', `File exceeds 2MB limit, size is: ${ Math.round(event.file.size / 1000000) }MB`, 'danger', 'right', 'bottom-right');
        }
      }
    });

    document.addEventListener('trix-attachment-add', event => {
      const { attachment } = event;

      if(attachment.file) {
        this.uploadFile(attachment, attributes => {
          const { url, href } = attributes;
          attachment.setAttributes({ url, href });
        });
      }
    });
  };

  uploadFile = (attachment, progressCallback, successCallback) => {
    var file = attachment.file;
    var notesAttachmentsRef = this.context.storageBucketRef.child('notes-attachments');
    // var attachmentRef = notesAttachmentsRef.child(file.lastModified + file.name);
    var attachmentRef = notesAttachmentsRef.child(file.name);
    var metaData = {
      contentType: file.type
    }
    this.uploadTask = attachmentRef.put(attachment.file, metaData);

    this.uploadTask.on('state_changed', snapshot => {
      // Upload in progress
      var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      console.log('Upload is ' + progress + '% done');
      attachment.setUploadProgress(progress);
    }, (error) => {
      // Upload error
      console.log('Error: ' + error);
    }, () => {
      // Upload completed
      this.uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
        attachment.setAttributes({
          url: downloadURL,
          href: downloadURL
        })
        console.log('File available at', downloadURL);
        debugger
        this.props.updateNotes(this.state.notes);
      }.bind(this));
    });
  };

  toggleNotes = () => {
    this.props.toggleNotes();
    this.props.toggleActions();
    this.props.updateNotes(this.state.notes);
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(this.editor && this.props !== prevProps) {
      this.setState({
        notes: this.props.content
      }, () => {
        this.editor.loadHTML(this.state.notes);
      });
    }
  };

  render() {
    return (
      <div className={`notes ${ this.props.isVisible && this.props.actionsVisible ? 'is-visible' : '' }`}>
        <div className="notes__overlay" onClick={ this.toggleNotes }></div>
        <div className="notes__container">
          <TrixEditor
            onChange={ this.handleChange }
            onEditorReady={ this.handleEditorReady }
          />
        </div>
      </div>
    );
  };
}

export default Notes;
